import React from "react";
import { ForgotPasswordForm } from "components/Forms/ForgotPassword";

export function ForgotPasswordModal(): JSX.Element {
  return <ForgotPasswordForm inModal />;
}
